import { useLayoutEffect } from "react"
import { getPageTitle } from "utils/helpers/get-page-title";

export const usePageTitle = (pageTitle = 'HOST Admin') =>  {
    useLayoutEffect(() => {
        document.title = getPageTitle(pageTitle);
    }, [pageTitle])
};
